import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

interface EmptySheetPreviewProps {
  rows?: number;
  columns?: number;
}

export default function EmptySheetPreview({
  rows = 5,
  columns = 4,
}: EmptySheetPreviewProps) {
  return (
    <TableContainer
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: '4px',
        my: 2,
      }}
    >
      <Table size="small">
        <TableBody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {Array.from({ length: columns }).map((_, columnIndex) => (
                <TableCell
                  key={columnIndex}
                  sx={{
                    height: 33,
                    borderRight: 1,
                    borderColor: 'divider',
                    '&:last-child': {
                      borderRight: 'none',
                    },
                  }}
                />
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
